export const loader_sizes = {
  small: "small",
  base: "base",
  large: "large",
};
